import * as React from 'react'
import styled from 'styled-components'
import { media } from '../utils/media'

const Container = styled.div`
  display: inline-block;
`

const ScaleItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`

const ScaleLine = styled.div<{ checked: boolean }>`
  width: 6px;
  height: 1px;
  background: ${({ checked }) => checked ? '#3DD7B1' : '#FA8D2D' };

  ${media.tablet`
    width: 10px;
  `}
`

const ScaleItem = styled.button<{ checked: boolean }>`
  appearance: none;
  border-radius: 100%;
  width: 35px;
  height: 35px;
  line-height: 21px;
  border: 1px solid ${({ checked }) => checked ? '#3DD7B1' : '#FA8D2D' };
  background: ${({ checked }) => checked ? '#3DD7B1' : 'white' };
  color: ${({ checked }) => checked ? 'white' : '#172129' };
  padding: 0;

  font-family: Nunito;
  font-size: 16px;
  font-weight: 900;

  ${media.tablet`
    width: 38px;
    height: 38px;
    line-height: 34px;
    font-size: 20px;
  `}
`

const Labels = styled.div`
  margin-top: 7px;
  display: flex;
  justify-content: space-between;

  font-family: "SF Pro Display";
  font-size: 14px;
  color: #AEBFCC;
`

interface IProps {
  disabled?: boolean
  from: number
  to: number
  value: number | null
  onChange?: (value: number) => void
  fromLabel?: string
  toLabel?: string
  [key: string]: any
}

export const Scale = ({ disabled, from, to, value, fromLabel, toLabel, onChange, ...rest }: IProps) => {
  return (
    <Container>
      <ScaleItems>
        {range(from, to).map(i =>
          <React.Fragment key={i}>
            {from !== i &&
              <ScaleLine checked={value !== null && i <= value} />
            }
            <ScaleItem
              // tslint:disable-next-line:jsx-no-lambda
              key={i} checked={value !== null && i <= value} onClick={(e) => onChange && onChange(i)}
              disabled={disabled}
            >{i}</ScaleItem>
          </React.Fragment>,
        )}
      </ScaleItems>
      {(fromLabel || toLabel) && <Labels><div>{fromLabel}</div><div>{toLabel}</div></Labels>}
    </Container>
  )
}

function range (from: number, to: number) {
  const result: number[] = []

  for (let i = from; i <= to; i++) { result.push(i) }

  return result
}



// WEBPACK FOOTER //
// ./src/atoms/Scale.tsx